// src/components/Dashboard.tsx
import React from 'react';
import { Progress } from 'antd'; // Used for the circle chart
import ProjectSummaryCard from './ProjectSummaryCard';
import ProjectDetailItem from './ProjectDetailItem';
import AccountSummaryStat from './AccountSummaryStat';
import {
  projectSummaries,
  projectDetails,
  accountOverviewData,
} from './dashboardConfigs'; // Adjust path as necessary

const BDETrackerDashboard: React.FC = () => {
  const percentageAdded = (accountOverviewData.added / accountOverviewData.target) * 100;

  return (
    <div className="mt-6 ">
      <div className="flex space-x-3">
        {/* === Project Overview Panel === */}
        <div className="flex-1 bg-white rounded-xl  border border-gray-100">
          <h2 className="text-xl font-semibold p-6 border-b">Project Overview</h2>
          <div className="flex">
            {/* Left Column: Summary Cards */}
            <div className="w-1/3 border-r p-4 space-y-2">
              {projectSummaries.map((summary) => (
                <div key={summary.label} className="flex items-center space-x-4">
                  {/* Reuse the ProjectSummaryCard style for visual consistency */}
                  <ProjectSummaryCard data={summary} />
                </div>
              ))}
            </div>

            {/* Right Column: Project Details List */}
            <div className="w-2/3">
              {projectDetails.map((detail, index) => (
                <ProjectDetailItem key={index} data={detail} />
              ))}
            </div>
          </div>
        </div>

        {/* === Account Overview Panel === */}
        <div className="w-[30%] bg-white rounded-xl  border border-gray-100">
          <div className="flex justify-between items-center p-6 border-b">
            <h2 className="text-xl font-semibold">Account Overview</h2>
          </div>

          <div className="p-6">
            {/* Target and Status */}
            <div className="flex justify-between text-sm mb-4">
              <div className="text-gray-500">
                Target: **{accountOverviewData.target}** Account/Month
              </div>
              <div className="text-green-600 text-xs font-medium px-2 py-0.5 rounded-full bg-green-100">
                {accountOverviewData.status}
              </div>
            </div>

            {/* Progress Circle and Stats */}
            <div className="flex space-x-6 items-center">
              {/* Circle Chart */}
              <div className="relative flex items-center justify-center w-1/2">
                <Progress
                  type="circle"
                  percent={percentageAdded}
                  width={150}
                  strokeColor={{
                    '0%': '#A78BFA', // Purple start
                    '100%': '#7C3AED', // Purple end
                  }}
                  trailColor="#F3F4F6"
                  format={() => (
                    <div className="flex flex-col">
                      <span className="text-4xl font-bold text-gray-800">
                        {accountOverviewData.added}
                      </span>
                      <span className="text-sm text-gray-500">Accounts Added</span>
                    </div>
                  )}
                />
              </div>

              {/* Account Summary Stats */}
              <div className="w-1/2">
                {accountOverviewData.summaryItems.map((item) => (
                  <AccountSummaryStat key={item.label} data={item} />
                ))}
              </div>
            </div>
          </div>

          {/* Recently Added Section */}
          <div className="p-6 pt-0">
            <div className="text-sm text-gray-500 mb-2">Recently added</div>
            <div className="flex space-x-4 overflow-x-auto">
              {accountOverviewData.recentlyAdded.map((account, index) => (
                <div
                  key={index}
                  className="p-3 bg-gray-100 rounded-lg min-w-[45%]"
                >
                  <div className="font-medium text-xs text-gray-800 truncate">
                    {account.name}
                  </div>
                  <div className="text-xs text-gray-500">{account.role}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BDETrackerDashboard;






